import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import LoaderOverlay from '../../LoaderOverlay/LoaderOverlay';

export default function HelpCenterHomePage({ get_articles_endpoint, isDay1 }) {
	const [
		articles,
		setArticles
	] = useState([]);
	const [
		loading,
		setLoading
	] = useState(true);
	const [
		error,
		setError
	] = useState(null);

	useEffect(
		() => {
			const fetchData = async () => {
				try {
					const response = await fetch(get_articles_endpoint);
					if (!response.ok) {
						throw new Error('Failed to fetch articles');
					}
					const result = await response.json();
					setArticles(result.data || []);
				} catch (error) {
					setError(
						error.message || 'An error occurred while fetching articles.'
					);
				} finally {
					setLoading(false);
				}
			};

			fetchData();
		},
		[
			get_articles_endpoint
		]
	);

	return (
		<div>
			<h1 className="text-5xl mb-4 text-center">Hi, how can we help?</h1>
			{isDay1 && (
				<div className="SearchBar text-center">
					<input
						className="SearchInput"
						type="text"
						placeholder="Search how-tos and more"
					/>
				</div>
			)}
			{loading && <LoaderOverlay />}
			{error && <div>Error: {error}</div>}
			{!loading &&
			!error && (
				<div className="py-6 md:py-14">
					{isDay1 && (
						<h2 className="text-2xl my-6 font-semibold">Top articles</h2>
					)}
					<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mt-6 lg:mt-16">
						{articles.map((article) => (
							<div key={article.id}>
								<div>
									<Link to={`/articles/${article.id}`}>
										<h3 className="underline font-semibold">{article.title}</h3>
									</Link>
									<span>{article.synopsis}</span>
								</div>
							</div>
						))}
					</div>
				</div>
			)}
		</div>
	);
}

HelpCenterHomePage.propTypes = {
	get_articles_endpoint: PropTypes.string.isRequired,
	isDay1: PropTypes.bool
};
